module.exports = __webpack_public_path__ + "static/img/wjfz_icon.79439f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wjfz_icon.png
// module id = qACm
// module chunks = 0